module.exports = __webpack_public_path__ + "img/whatsappIntegration.e10d1203.png";